<template>
  <div>
    <nav
      class="navbar navbar-expand-lg navbar-dark axion-navbar py-3 fixed-top"
    >
      <div class="container">
        <!-- Logo -->
        <router-link
          class="navbar-brand fw-bold glow-text d-flex align-items-center"
          to="/"
        >
          <i class="bi bi-atom me-2 text-pink fs-4"></i>
          Axion Academy
        </router-link>

        <!-- Mobile Toggle -->
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Menu -->
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ms-auto align-items-lg-center">
            <li class="nav-item mx-lg-2">
              <router-link class="nav-link" to="/">Home</router-link>
            </li>
            <li class="nav-item mx-lg-2">
              <router-link class="nav-link" to="#">Courses</router-link>
            </li>
            <li class="nav-item mx-lg-2">
              <router-link class="nav-link" to="/about">About Us</router-link>
            </li>
            <li class="nav-item mx-lg-2">
              <router-link class="nav-link" to="/contact">Contact</router-link>
            </li>
            <li class="nav-item mx-lg-2">
              <a
                class="btn btn-pink px-4 py-1"
                href="#"
                data-bs-toggle="modal"
                data-bs-target="#loginModal"
              >
                Login
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- Login Modal -->
    <LoginModal />
  </div>
</template>

<script setup>
import LoginModal from "./LoginModal.vue";
</script>

<style scoped>
.axion-navbar {
  background: linear-gradient(45deg, #2b0033, #9900ff);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.navbar-brand.glow-text {
  font-size: 1.4rem;
  text-shadow: 0 0 8px #ff00cc, 0 0 16px #ff00cc;
}

.nav-link {
  color: white !important;
  transition: 0.3s;
}

.nav-link:hover {
  color: #ff00cc !important;
}

.btn-pink {
  background: linear-gradient(45deg, #ff00cc, #9900ff);
  color: white;
  border: none;
  transition: 0.3s;
}

.btn-pink:hover {
  transform: translateY(-2px);
  box-shadow: 0 0 15px #ff00cc;
  color: white;
}

/* ===== MOBILE RESPONSIVE ===== */
@media (max-width: 992px) {
  .navbar-nav {
    text-align: center;
  }
  .nav-item {
    margin: 0.5rem 0;
  }
  .btn-pink {
    width: 80%;
    margin: 0.5rem auto;
  }
}
</style>
